var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamTabIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 5.96675C14.9504 5.95842 14.8921 5.95842 14.8421 5.96675C13.6921 5.92508 12.7754 4.98342 12.7754 3.81675C12.7754 2.62508 13.7337 1.66675 14.9254 1.66675C16.1171 1.66675 17.0754 2.63342 17.0754 3.81675C17.0671 4.98342 16.1504 5.92508 15.0004 5.96675Z",
    fill: "white",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 12.0333C15.2839 12.225 16.5422 12.025 17.4255 11.4333C18.6005 10.65 18.6005 9.36664 17.4255 8.58331C16.5339 7.99164 15.2589 7.79163 14.1172 7.99163",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97539 5.96675C5.02539 5.95842 5.08372 5.95842 5.13372 5.96675C6.28372 5.92508 7.20039 4.98342 7.20039 3.81675C7.20039 2.62508 6.24206 1.66675 5.05039 1.66675C3.85873 1.66675 2.90039 2.63342 2.90039 3.81675C2.90872 4.98342 3.82539 5.92508 4.97539 5.96675Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83353 12.0333C4.69186 12.225 3.43353 12.025 2.5502 11.4333C1.3752 10.65 1.3752 9.36664 2.5502 8.58331C3.44186 7.99164 4.71686 7.79163 5.85853 7.99163",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.1916C9.95039 12.1833 9.89206 12.1833 9.84206 12.1916C8.69206 12.1499 7.77539 11.2083 7.77539 10.0416C7.77539 8.84994 8.73372 7.8916 9.92539 7.8916C11.1171 7.8916 12.0754 8.85827 12.0754 10.0416C12.0671 11.2083 11.1504 12.1583 10.0004 12.1916Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57461 14.8166C6.39961 15.5999 6.39961 16.8832 7.57461 17.6666C8.90794 18.5582 11.0913 18.5582 12.4246 17.6666C13.5996 16.8832 13.5996 15.5999 12.4246 14.8166C11.0996 13.9332 8.90794 13.9332 7.57461 14.8166Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamTabIcon);
export default __webpack_public_path__ + "static/media/team-tab-icon.0d15761780fd1ee519bed8d81f0f8002.svg";
export { ForwardRef as ReactComponent };